import { createContext, useContext, useState, useCallback } from 'react';

const HeaderContext = createContext({
  pageTitle: '',
  setPageTitle: () => {},
  onBack: null,
  setOnBack: () => {},
  isCross: false,
  setIsCross: () => {},
  pageTitleKey: '',
  setPageTitleKey: () => {},
});

export function HeaderProvider({ children }) {
  const [pageTitle, setPageTitle] = useState('');
  const [onBack, setOnBack] = useState(null);
  const [isCross, setIsCross] = useState(false);
  const [pageTitleKey, setPageTitleKey] = useState('');

  const setOnBackFn = useCallback((fn) => {
    setOnBack(fn ? () => fn : null);
  }, []);

  return (
    <HeaderContext.Provider value={{ pageTitle, setPageTitle, onBack, setOnBack: setOnBackFn, isCross, setIsCross, pageTitleKey, setPageTitleKey }}>
      {children}
    </HeaderContext.Provider>
  );
}

export function useHeader() {
  return useContext(HeaderContext);
}